import React, { useEffect, useState } from "react"
import { CountrySelector } from "./CountrySelector"
import { MobileNumberInput } from "./MobileNumberInput"
import { OtpInput } from "./OtpInput"
import { Button } from "./Button"
import { Input } from "./Input"
import { TimerDisplay } from "./TimerDisplay"
import { EditInfoButton } from "./EditInfoButton"
import { getOTPRequest, signupRequest } from "../../redux/actions/auth"
import { GET_OTP_RESET, SIGNUP_RESET } from "../../redux/types/auth"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { toast } from "react-toastify"
import ErrorPopup from "components/ErrorPopup"

export const SignupForm = props => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [isErrorOpen, setIsErrorOpen] = useState(false)
  const [isErrorMessage, setIsErrorMessage] = useState("")
  const [firstName, setFirstName] = useState("")
  const [lastName, setLastName] = useState("")
  const [email, setEmail] = useState("")
  const [selectedCountry, setSelectedCountry] = useState("IN")
  const [mobileNumber, setMobileNumber] = useState("")
  const [otp, setOtp] = useState("")
  const [isLoading, setIsLoading] = useState(false)
  const [showOtpInput, setShowOtpInput] = useState(false)
  const [isNumberLocked, setIsNumberLocked] = useState(false)
  const [otpError, setOtpError] = useState("")
  const [countdown, setCountdown] = useState(0)

  const getOTPScreen = useSelector(state => state.screens.getOTP)
  const signupScreen = useSelector(state => state.screens.signup)
  const user = useSelector(state => state.auth.user)

  useEffect(() => {
    if (props.mobileNumber) setMobileNumber(props.mobileNumber)
  }, [props.mobileNumber])

  useEffect(() => {
    if (getOTPScreen.success) {
      setShowOtpInput(true)
      setIsNumberLocked(true)
      setCountdown(60)
      dispatch({ type: GET_OTP_RESET })
    }
    if (signupScreen.success) {
      setIsNumberLocked(false)
      setShowOtpInput(false)
      setOtp("")
      setCountdown(0)
      dispatch({ type: SIGNUP_RESET })
      if (props.state && props.state.from) {
        navigate(props.state.from, { replace: true })
      } else {
        if (user && (user.user_type == "admin" || user.user_type == "staff")) {
          navigate("/dashboard", { replace: true })
        } else navigate("/home", { replace: true })
      }
    }

    if (signupScreen.error) {
      toast.error(signupScreen.error || "Login failed. Please try again.")
      dispatch({ type: SIGNUP_RESET })
    }

    if (getOTPScreen.error) {
      setIsErrorMessage(getOTPScreen.error)
      setIsErrorOpen(true)
      // toast.error(getOTPScreen.error || "An error occurred. Please try again.")
      // props.switchToSignup(mobileNumber);
      // setMessage(
      //   getOTPScreen.error ||
      //     "An error occurred. Please try again or contact support."
      // )
      // setIsOpen(true)
    }
  }, [getOTPScreen, signupScreen])

  const handleGetOTP = e => {
    e.preventDefault()

    dispatch(getOTPRequest({ auth_type: "signup", mobile_no: mobileNumber }))
  }

  const handleSignup = e => {
    e.preventDefault()
    dispatch(
      signupRequest({
        first_name: firstName,
        last_name: lastName,
        mobile_no: mobileNumber,
        mobile_otp: otp,
        email_id: email,
      })
    )
  }

  const handleEdit = () => {
    setIsNumberLocked(false)
    setShowOtpInput(false)
    setOtp("")
    setOtpError("")
    setCountdown(0)
  }

  const resendOTP = () => {
    dispatch(getOTPRequest({ mobile_no: mobileNumber }))
  }

  React.useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000)
      return () => clearTimeout(timer)
    }
  }, [countdown])

  const isGetOtpValid =
    firstName &&
    lastName &&
    email &&
    mobileNumber.length === 10 &&
    !showOtpInput
  const isSignupValid = otp.length === 4 && showOtpInput

  return (
    <form
      onSubmit={showOtpInput ? handleSignup : handleGetOTP}
      className="login-form"
    >
      <fieldset className="form-fieldset">
        <legend className="sr-only">Sign Up Form</legend>

        <div className="name-fields">
          <div className="name-field">
            <label htmlFor="first-name" className="label">
              First Name
            </label>
            <Input
              id="first-name"
              type="text"
              value={firstName}
              onChange={e => setFirstName(e.target.value)}
              placeholder="First Name"
              disabled={isLoading || isNumberLocked}
              className="name-input"
            />
          </div>

          <div className="name-field">
            <label htmlFor="last-name" className="label">
              Last Name
            </label>
            <Input
              id="last-name"
              type="text"
              value={lastName}
              onChange={e => setLastName(e.target.value)}
              placeholder="Last Name"
              disabled={isLoading || isNumberLocked}
              className="name-input"
            />
          </div>
        </div>

        <div className="form-field">
          <label htmlFor="email" className="label">
            Email
          </label>
          <Input
            id="email"
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder="Email Id"
            disabled={isLoading || isNumberLocked}
            className="email-input"
          />
        </div>

        <div className="label-container">
          <label htmlFor="mobile-number" className="label">
            WhatsApp Number
          </label>
        </div>

        <div
          className="input-group"
          role="group"
          aria-labelledby="mobile-input-group"
        >
          <span id="mobile-input-group" className="sr-only">
            Mobile number with country selector
          </span>

          <CountrySelector
            selectedCountry={selectedCountry}
            onCountryChange={setSelectedCountry}
            disabled={isNumberLocked}
          />

          <MobileNumberInput
            value={mobileNumber}
            onChange={setMobileNumber}
            disabled={isLoading || isNumberLocked}
          />
        </div>
        {isNumberLocked && <EditInfoButton onClick={handleEdit} />}

        {showOtpInput && (
          <div className="otp-section">
            <label htmlFor="otp-input" className="otp-label">
              OTP
            </label>
            <OtpInput value={otp} onChange={setOtp} disabled={isLoading} />
            {otpError && <div className="otp-error">{otpError}</div>}
            {countdown > 0 ? (
              <div className="otp-timer-container">
                <TimerDisplay seconds={countdown} />
              </div>
            ) : (
              <div className="otp-timer-container">
                <button
                  type="button"
                  onClick={resendOTP}
                  className="edit-button"
                >
                  Resend OTP
                </button>
              </div>
            )}
          </div>
        )}

        <div className="button-container">
          <Button
            type="submit"
            disabled={(!isGetOtpValid && !isSignupValid) || isLoading}
            variant={isGetOtpValid || isSignupValid ? "active" : "default"}
            aria-describedby="button-help"
          >
            {isLoading ? "Loading..." : showOtpInput ? "Sign Up" : "Get OTP"}
          </Button>
        </div>
      </fieldset>
      <ErrorPopup
        isOpen={isErrorOpen}
        toggle={() => setIsErrorOpen(!isErrorOpen)}
        title="System Under Development"
        message={isErrorMessage}
      />
    </form>
  )
}
